import { Typography } from "antd";
import CompOffPolicyForm from "../compOffPolicy/CompOffPolicyForm";

export default function LeavePolicyComboPanel() {
	return (
		<div className="leave-policy-combo-panel">
			<Typography.Title level={5} className="leave-policy-combo-panel-title">
				Combo-Off Policy
			</Typography.Title>
			<CompOffPolicyForm embedded sidePanel />
		</div>
	);
}
